// Marca visible en todo el sitio (co-branding configurable por despliegue).
// Único punto de verdad: NO redeclarar por página ni hardcodear otra marca.
export const COMPANY = process.env.REACT_APP_COMPANY_NAME || 'Conectividad para Eventos'

export const T = {
  bg:            '#110f0c',
  bgElevated:    '#181511',
  bgSubtle:      '#14110d',
  border:        '#2a2520',
  borderHover:   '#3a342c',
  accent:        '#d48830',
  rouge:         '#b03544',
  textPrimary:   '#f5ede0',
  textSecondary: '#c0b09a',
  textMuted:     '#998970',
  textFaint:     '#5e554a',
  accentBg:      'rgba(212,136,48,0.10)',
  hoverOverlay:  'rgba(212,136,48,0.06)',
}

export const serif = '"Cormorant Garamond", serif'
export const mono  = '"JetBrains Mono", monospace'
export const body  = '"Inter Tight", sans-serif'

// Shared input styles (MUI)
export const inputSx = {
  "& .MuiInputBase-root": {
    background: T.bgSubtle,
    color: T.textPrimary,
    fontFamily: body,
    fontSize: "0.9rem",
    borderRadius: "6px",
  },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: T.border },
  "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: T.borderHover,
  },
  "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: T.accent,
  },
  "& .MuiInputLabel-root": {
    color: T.textMuted,
    fontFamily: body,
    fontSize: "0.85rem"
  },
  "& .MuiInputLabel-root.Mui-focused": { color: T.accent },
  "& input[type='datetime-local']::-webkit-calendar-picker-indicator": {
    filter: "invert(0.6) sepia(1) saturate(3) hue-rotate(10deg)",
    cursor: "pointer",
  },
}
